import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './clearance.css';
import { EDIT_TYPE } from '@src/slide/domain/selection/constant/edit-type';
import PopupWrapper, { PopupMenuType } from '@com-pc/popup-wrapper/index';

interface IClearanceProps {
    style?: React.CSSProperties;
    clearanceIndex: number;
    sectionIndex?: number;
    editType?: string;
    handleClickClearance: (e: MouseEvent, index: number) => void;
    opacity: number;
}

export default class Clearance extends Component<IClearanceProps> {
    public static propTypes = {
        handleClickClearance: PropTypes.func,
        style: PropTypes.object,
        clearanceIndex: PropTypes.number,
    };

    public handleClearanceClick = (e: MouseEvent): void => {
        e.preventDefault();
        this.props.handleClickClearance(e, this.props.clearanceIndex);
    };

    public render(): React.ReactNode {
        const {
            style,
            sectionIndex,
            clearanceIndex,
            editType,
        } = this.props;
        const popupMenuType = editType === EDIT_TYPE.MASTER_LAYOUT
            ? PopupMenuType.LAYOUT_MASTER_GAP
            : PopupMenuType.SLIDE_GAP;
        return (
            <div
                className={styles.slideClearance}
                style={style}
                onMouseDown={this.handleClearanceClick.bind(this)}
            >
                <PopupWrapper
                    type={popupMenuType}
                    style={{ display: 'flex' }}
                    index={clearanceIndex}
                    sectionIndex={sectionIndex}
                >
                    {this.props.opacity === 1 ? (
                        <div className={styles.clearanceWithAnim} />
                    ) : (
                        <div className={styles.clearance} />
                    )}
                </PopupWrapper>
            </div>
        );
    }
}
